import React, {FC, ReactElement} from 'react';
import {SearchProvider, SimpleSearchProvider, WebConfigProvider} from '@context';
import {Router} from '@router';
import {createMuiTheme, ThemeProvider} from '@material-ui/core';
import {ProviderComposer} from '@components';

const defaultTheme = createMuiTheme();
const theme = createMuiTheme({
    breakpoints: {
        values: {
            ...defaultTheme.breakpoints.values,
            md: 840
        }
    },
    palette: {
        text: {
            primary: '#434a57',
            secondary: '#859db3',
            disabled: '#d4d4d5',
            link: '#007bff',
            black: '#000000',
            white: '#ffffff',
            dark: '#303030'
        },
        divider: '#e2e2e3'
    },
    typography: {
        fontFamily: 'Lato'
    },
});


const App: FC = (): ReactElement => (
    <ProviderComposer components={[[ThemeProvider, {theme}], SimpleSearchProvider, SearchProvider, WebConfigProvider]}>
        <Router/>
    </ProviderComposer>
);

export default App;
